import { render } from "@testing-library/react";
import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import $ from "jquery";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { GetEmpAssessmentPeriodList } from "./PMSService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const faqs = [
  { id: 1, title: "Deliverables & Customer Focus", weightage: 50 },
  { id: 2, title: "Technical Competence & Strength", weightage: 20 },
  { id: 3, title: "Behavioural Strength/TeamWork", weightage: 10 },
  { id: 4, title: "Accountability & Communication", weightage: 10 },
  { id: 5, title: "Development Areas", weightage: 10 },
];
function TeamAssessment() {
  const [activeFAQIndex, setActiveFAQIndex] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [ticketDataCount, setTicketDataCount] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const selectedColumns = [
    "RequestTitle",
    "RequestNumber",
    "CreatedDate",
    "EmployeeFullName",
    "RequestStatus",
    "CategoryName",
    "SubCategoryName",
    "AssignToName",
    "Priority",
    "PriorityName",
    "Severity",
    "SeverityName",
  ];
  const [selectedTicket, setSelectedTicket] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  // const [deleteTicketId, setDeleteTicketId] = useState(0); // not use for now.
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [ticketStatusType, setTicketStatusType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [filterStartDate, setFilterStartDate] = useState("02/01/2016");
  const [filterEndDate, setFilterEndDate] = useState("02/01/2029");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedAssingToName, setSelectedAssingToName] = useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [selectedRaiseBy, setSelectedRaiseBy] = useState(null);
  const [ticketDataMessage, setTicketDataMessage] = useState("");
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  const [userAddPermission, setUserAddPermission] = useState(false);
  const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";

  useEffect(() => {
    getEmpAssessmentPeriodList();
  }, []);

  async function getEmpAssessmentPeriodList() {
    setLoading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      OAPGuId: "",
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let LikeList = await GetEmpAssessmentPeriodList(body);
      setEmpAssessmentList(LikeList?.Data?.assessmentPresiodResponse);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }
  const handleEdit = (id) => {
    // Implement edit logic
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);
  const handleDelete = (id) => {
    // Implement delete logic
  };

  function myFunction() {
    var x = document.getElementById("myDIV2");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  }

  function showPopup() {
    $(".Show-upload-div").click(function () {
      $(".upload-img").show("slow");
    });
    $(".Hide-upload-div").click(function () {
      $(".upload-img").hide("slow");
    });
  }
  function ShowUploadDiv2() {
    $(".Show-upload-div2").click(function () {
      $(".upload-emoji").show("slow");
    });
    $(".Hide-upload-div2").click(function () {
      $(".upload-emoji").hide("slow");
    });
  }

  const requestStatusEditor = (options) => {
    return (
      <Dropdown
        value={ticketStatusType.find((status) => status.Name == options.value)}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketStatusType}
        optionLabel="Name"
        placeholder="Status"
        className="w-full md:w-14rem"
      />
    );
  };

  const assignToEditor = (options) => {
    return (
      <Dropdown
        value={employeDetails.find((name) => name.FullName == options.value)}
        onChange={(e) => options.editorCallback(e.value.FullName)}
        options={employeDetails}
        optionLabel="FullName"
        placeholder="Assign"
        itemTemplate={employeeOptionTemplate}
        filter
        className="w-full md:w-14rem"
      />
    );
  };

  const priorityEditor = (options) => {
    return (
      <Dropdown
        value={ticketPriorityType.find(
          (priority) => priority.Name == options.value
        )}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketPriorityType}
        optionLabel="Name"
        placeholder="Priority"
        className="w-full md:w-14rem"
      />
    );
  };
  const RaiseByEditor = (options) => {
    return (
      <div className="d-flex">
        <span className="w-space-no">{options.value}</span>
      </div>
    );
  };

  const categoryEditor = (options) => {
    let categoryId = ticketCategoryType.find(
      (catName) => catName.Name == options.value
    );
    if (categoryId) {
      setSelectedCategory(categoryId);
    }
    return (
      <Dropdown
        value={ticketCategoryType.find(
          (category) => category.Name == options.value
        )}
        onChange={(e) => {
          options.editorCallback(e.value.Name);
          setSelectedCategory(e.value);
        }}
        options={ticketCategoryType}
        optionLabel="Name"
        placeholder="Category"
        className="w-full md:w-14rem"
      />
    );
  };

  const subCategoryEditor = (options) => {
    return (
      <Dropdown
        value={ticketSubcategoryTypeSelected.find(
          (subCategory) => subCategory.Name == options.value
        )}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketSubcategoryTypeSelected}
        optionLabel="Name"
        placeholder="SubCategory"
        className="w-full md:w-14rem"
      />
    );
  };

  const serverityEditor = (options) => {
    return (
      <Dropdown
        value={ticketSeverityType.find(
          (serverity) => serverity.Name == options.value
        )}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketSeverityType}
        optionLabel="Name"
        placeholder="Serverity"
        className="w-full md:w-14rem"
      />
    );
  };

  const assignBodyTemplate = (rowData) => {
    if (rowData.AssignedToId != 0) {
      return (
        <Link to={`/Profile/${rowData.GUID}`}>
          <div className="d-flex">
            <img
              src={rowData?.AssignToProfileImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="18"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData?.AssignToName}</span>
          </div>
        </Link>
      );
    }
    return <span>Not Assigned</span>;
  };

  const serverityContent = (rowData) => {
    return (
      <span>
        {rowData?.SeverityName == "Low" && <span className="low-pri">Low</span>}
        {rowData?.SeverityName == "Medium" && (
          <span className="med-pri">Medium</span>
        )}
        {rowData?.SeverityName == "High" && (
          <span className="high-pri">High</span>
        )}
      </span>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // let EmpAssessmentList = [{
  //   "TotalTicketCount": 1,
  //   "TicketStatusCounts": [
  //     {
  //       "RequestStatusId": 101,
  //       "Status": "New",
  //       "TicketCount": 1
  //     }
  //   ],
  //   "OrgEmpRequests": [
  //     {
  //       "TotalCount": 1,
  //       "ObserverLists": [],
  //       "Attachments": [],
  //       "RequestHistory": [
  //         {
  //           "RequestTitle": "Savita Rana",
  //           "RequestDescription": "test",
  //           "SeverityName": "Medium",
  //           "PriorityName": "P2",
  //           "CategoryName": "Finance",
  //           "SubCategoryName": "Savings Accounts",
  //           "AssignToName": "",
  //           "AssignToProfileImage": "",
  //           "AssignToUserName": "",
  //           "RequestStatus": "New",
  //           "EmployeeFullName": "Ajay Spire",
  //           "EmployeeUserName": "OrgGenTest+1@gmail.com",
  //           "EmployeeProfileImage": "",
  //           "RequestNumber": null,
  //           "HistoryTitle": "Modified by Ajay Spire on 28 Jun 2025",
  //           "AssignedToId": 0,
  //           "RequestId": 364,
  //           "RequestCategoryId": 102,
  //           "RequestSubCategoryId": 105,
  //           "RequestStatusId": 101,
  //           "Comment": "",
  //           "Severity": 102,
  //           "Priority": 102,
  //           "EmpId": 101,
  //           "OrgId": 101,
  //           "Id": 772,
  //           "GUID": "8c69b3f4-1061-4846-b398-00dd3fa7b3f3",
  //           "IsActive": true,
  //           "CreatedDate": "2025-06-28T13:11:22.253",
  //           "ModifiedDate": "2025-06-28T13:11:22.253",
  //           "CreatedBy": 101,
  //           "ModifiedBy": 101
  //         }
  //       ],
  //       "RequestTitle": "Service",
  //       "RequestDescription": "test",
  //       "SeverityName": "Medium",
  //       "PriorityName": "P2",
  //       "CategoryName": "Finance",
  //       "SubCategoryName": "Savings Accounts",
  //       "AssignToName": "",
  //       "AssignToProfileImage": "",
  //       "AssignToUserName": "",
  //       "RequestStatus": "New",
  //       "EmployeeFullName": "Ajay Spire",
  //       "EmployeeUserName": "OrgGenTest+1@gmail.com",
  //       "EmployeeProfileImage": "",
  //       "RequestNumber": "Closed",
  //       "HistoryTitle": "Modified by Ajay Spire on 28 Jun 2025",
  //       "AssignedToId": 0,
  //       "RequestId": 364,
  //       "RequestCategoryId": 102,
  //       "RequestSubCategoryId": 105,
  //       "RequestStatusId": 101,
  //       "Comment": "",
  //       "Severity": 102,
  //       "Priority": 102,
  //       "EmpId": 101,
  //       "OrgId": 101,
  //       "Id": 364,
  //       "GUID": "aa095eee-b86b-4c98-b254-9d1ec2f2100e",
  //       "IsActive": true,
  //       "CreatedDate": "2025-06-28T13:11:22.253",
  //       "ModifiedDate": "2025-06-28T13:11:22.253",
  //       "CreatedBy": 101,
  //       "ModifiedBy": 101
  //     }
  //   ]
  // }];

  // let EmpAssessmentList = [
  //   {
  //     "TotalCount": 1,
  //     "ObserverLists": [],
  //     "Attachments": [],
  //     "RequestHistory": [
  //       {
  //         "RequestTitle": "Service",
  //         "RequestDescription": "test",
  //         "SeverityName": "Medium",
  //         "PriorityName": "P2",
  //         "CategoryName": "Finance",
  //         "SubCategoryName": "Savings Accounts",
  //         "AssignToName": "",
  //         "AssignToProfileImage": "",
  //         "AssignToUserName": "",
  //         "RequestStatus": "New",
  //         "EmployeeFullName": "Ajay Spire",
  //         "EmployeeUserName": "OrgGenTest+1@gmail.com",
  //         "EmployeeProfileImage": "",
  //         "RequestNumber": null,
  //         "HistoryTitle": "Modified by Ajay Spire on 28 Jun 2025",
  //         "AssignedToId": 0,
  //         "RequestId": 364,
  //         "RequestCategoryId": 102,
  //         "RequestSubCategoryId": 105,
  //         "RequestStatusId": 101,
  //         "Comment": "",
  //         "Severity": 102,
  //         "Priority": 102,
  //         "EmpId": 101,
  //         "OrgId": 101,
  //         "Id": 772,
  //         "GUID": "8c69b3f4-1061-4846-b398-00dd3fa7b3f3",
  //         "IsActive": true,
  //         "CreatedDate": "2025-06-28T13:11:22.253",
  //         "ModifiedDate": "2025-06-28T13:11:22.253",
  //         "CreatedBy": 101,
  //         "ModifiedBy": 101
  //       }
  //     ]
  //   }]

  const onPageChange = (e) => {
    setCurrentPage(e.page);
    setRowsPerPage(e.rows);
  };

  const filterColumns = (data) => {
    return data.map((item) =>
      selectedColumns.reduce((obj, key) => {
        if (item[key] !== undefined) {
          obj[key] = item[key];
        }
        return obj;
      }, {})
    );
  };

  const onSelectionChange = (event) => {
    const selectedValues = filterColumns(event.value);
    setSelectedTicket(selectedValues);
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = EmpAssessmentList.slice(startIndex, endIndex);
    setSelectAll(selectedValues?.length === visibleRows?.length);
  };

  const onSelectAllChange = (event) => {
    const isChecked = event.checked;
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = filterColumns(
      EmpAssessmentList.slice(startIndex, endIndex)
    );

    if (isChecked) {
      // Select only the visible rows with filtered fields
      setSelectAll(true);
      setSelectedTicket([...selectedTicket, ...visibleRows]);
    } else {
      // Deselect only the visible rows with filtered fields
      setSelectAll(false);
      const updatedSelection = selectedTicket.filter(
        (ticket) => !visibleRows.some((row) => row.TicketNO === ticket.TicketNO) // Use unique identifier
      );
      setSelectedTicket(updatedSelection);
    }
  };

  const nameBodyTemplate = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.GUID}`}>
        <div className="d-flex">
          {/* <img
            src={
              rowData?.RequestHistory[0]?.EmployeeProfileImage || defaultImage
            }
            onError={handleImageError}
            className="rounded-lg me-2"
            width="18"
            alt=""
          />*/}
          <span className="w-space-no">
            {/* {rowData?.RequestHistory[0]?.EmployeeFullName} */}
          </span>
        </div>
      </Link>
    );
  };
  const onRowEditComplete = async (e) => {
    setIsloading(true);
  };

  const requestTitle = (rowData) => {
    const maxLength = 25; // Maximum character length
    const truncatedTitle =
      rowData.RequestTitle?.length > maxLength
        ? `${rowData.RequestTitle.substring(0, maxLength)}...`
        : rowData.RequestTitle;

    if (
      userDetails?.EmpId === rowData?.AssignedToId &&
      userUpdatePermission === false
    ) {
      // Render as for a user without permission  but ticket his ticket
      return (
        <div className="d-flex">
          <Link
            to={`/Ticket/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            className="editbtncss"
          >
            {truncatedTitle}
          </Link>
        </div>
      );
    } else if (
      userDetails?.EmpId === rowData?.AssignedToId ||
      userUpdatePermission === true
    ) {
      // Render with a link for users with permission or assigned users
      return (
        <div className="d-flex">
          <Link
            to={`/Ticket/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle} // Full title on hover
            className="editbtncss"
          >
            {truncatedTitle}
          </Link>
        </div>
      );
    } else {
      // Render as for users without permission or assignment
      return (
        <div className="d-flex">
          <div
            title={rowData.RequestTitle} // Full title on hover
            className="editbtncss"
          >
            {truncatedTitle}
          </div>
        </div>
      );
    }
  };

  const RequestTitleEditor = (options) => {
    return (
      <div className="d-flex">
        <span className="w-space-no">{options.value}</span>
      </div>
    );
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  useEffect(() => {
    // //  use  for the selectCategory.
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === selectedCategory?.Id
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
    if (selectedTicket) {
    }
  }, [selectedCategory, selectedTicket]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (name == "CreatedDate") {
      setStartDate(value);
      let startDate = formatDate(value);
      value = startDate;
      setFilterStartDate(value);
    } else if (name == "EndDate") {
      setEndDate(value);
      let endDate = formatDate(value);
      value = endDate;
      setFilterEndDate(formatDate(value));
    }
    setSearchTerm({ [name]: value });
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Team Assessment</h2>
              </div>
              <div className="rightside-tabs">
                <select className="form-control">
                  <option disabled>Select Period</option>
                  <option selected>01 April 2022 - 31 March 2023</option>
                  <option>01 April 2021 - 31 March 2022</option>
                  <option>01 April 2020 - 31 March 2021</option>
                </select>

                <button
                  className="cancelbutton w-auto float-right"
                  style={{ minWidth: "fit-content" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    fill="currentColor"
                    className="bi bi-arrow-left me-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    ></path>
                  </svg>
                  Back
                </button>
              </div>
            </div>
          </div>

          <div className="col-xl-12 d-none">
            <strong className="assessment-title">Eligible Employees</strong>
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-4">
                  <div className="me-auto w-50">
                    <input
                      type="text"
                      placeholder="search..."
                      className="form-control"
                      style={{ height: "41px" }}
                    />
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="employee-card tile-grid tile-grid-v1">
                    <div className="table-responsive emp-table">
                      {/* dataTable no-footer */}
                      <table
                        id="example"
                        className="table table-striped table-bordered dataTable no-footer"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "50px" }}>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="checkAll"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkAll"
                                ></label>
                              </div>
                            </th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Assigned To</th>
                            <th>Score</th>
                            <th>Rating</th>
                            <th>Rating Scale</th>
                            <th>First Reviewer</th>
                            <th>Second Reviewer</th>
                            <th>HR</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/6.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Savita Rana
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Closed</td>
                            <td>
                              Arun Mishra
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Vital Performance</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/8.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Sonal</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/1.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Anubhav Singh
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>

                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/2.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Dharmesh tyagi
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/3.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Rashika</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto w-20">
                    <strong
                      className="ticket-title m-0"
                      style={{ fontWeight: "bolder" }}
                    >
                      All Employees
                    </strong>
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                  {/* <div className="actionbutton-tickets">
                    <input className="form-control mr-2 p-inputtext p-component" name="requestTitle" placeholder="Search" data-pc-name="inputtext" data-pc-section="root" />
                    <button className="export-btn" data-toggle="tooltip" data-placement="top" aria-label="Export" data-bs-original-title="Export">
                      <img src="/images/excels.png" alt="export" style={{ width: " 21px" }} /></button>
                  </div> */}
                </div>
                <div className="form-head d-none flex-wrap align-items-center bottom-head">
                  {/* <span className="fil-name">Filter</span> */}
                  <div className="saving-btn00 d-flex w-100">
                    <div className="d-flex d-flexx">
                      <Dropdown
                        name="assignToName"
                        className="w-full md:w-14rem"
                        value={selectedAssingToName}
                        onChange={(e) => {
                          setSelectedAssingToName(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails?.toSpliced(0, 0, {
                          id: 0,
                          FullName: "All",
                        })}
                        itemTemplate={employeeOptionTemplate}
                        filter
                        optionLabel="FullName"
                        placeholder="Assign To"
                      />
                      <Dropdown
                        name="fullName"
                        className="w-full md:w-14rem"
                        value={selectedRaiseBy}
                        onChange={(e) => {
                          setSelectedRaiseBy(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails?.toSpliced(0, 0, {
                          id: 0,
                          FullName: "All",
                        })}
                        itemTemplate={employeeOptionTemplate}
                        filter
                        optionLabel="FullName"
                        placeholder="Raise By"
                      />
                      <Dropdown
                        name="requestStatus"
                        className="w-full md:w-14rem"
                        // value={ticketMasterDataList?.ticketStatusTypes.find(
                        //   (statusId) => statusId.name == selectedStatus
                        // )}
                        value={selectedStatus}
                        onChange={(e) => {
                          setSelectedStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        placeholder="Status"
                      />
                      <Dropdown
                        name="CategoryName"
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketCategoryType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Category"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        disabled={!ticketSubcategoryTypeSelected}
                        name="subCategory"
                        value={selectedSubCategory}
                        onChange={(e) => {
                          setSelectedSubCategory(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketSubcategoryTypeSelected?.toSpliced(
                          0,
                          0,
                          { Id: 0, Name: "All" }
                        )}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Sub Category"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        name="priority"
                        value={selectedPriority}
                        onChange={(e) => {
                          setSelectedPriority(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketPriorityType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Priority"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        name="SeverityName"
                        value={selectedServerity}
                        onChange={(e) => {
                          setSelectedServerity(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketSeverityType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Serverity"
                        className="w-full md:w-14rem"
                      />
                      <span className="startdatefilter">Start Date</span>
                      <InputText
                        type="date"
                        name="CreatedDate"
                        placeholder="Date"
                        className="form-control mr-2"
                        value={startDate}
                        onChange={handleInputChange}
                      />
                      <span className="enddatefilter">End Date</span>
                      <InputText
                        type="date"
                        name="EndDate"
                        placeholder="Date"
                        className="form-control mr-2"
                        value={endDate}
                        onChange={handleInputChange}
                        min={startDate}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="table table-bordered dataTable no-footer tickettable">
                    <DataTable
                      value={EmpAssessmentList}
                      paginator
                      rows={rowsPerPage}
                      first={currentPage * rowsPerPage}
                      totalRecords={totalRecords}
                      dataKey="RequestNumber"
                      lazy={true}
                      onPage={onPageChange}
                      emptyMessage={ticketDataMessage}
                      selection={selectedTicket}
                      onSelectionChange={onSelectionChange}
                      selectAll={selectAll}
                      onSelectAllChange={onSelectAllChange}
                      editMode="row"
                      onRowEditComplete={onRowEditComplete}
                      className="ticket-datatable"
                    >
                      <Column selectionMode="multiple" />
                      <Column
                        field="Title"
                        // body={requestTitle}
                        header="Title"
                        style={{ minWidth: "16rem" }}
                        // editor={(options) => RequestTitleEditor(options)}
                        sortable
                      />
                      <Column
                        field="AssesmentTemplateName"
                        header="Assesment Name"
                        style={{ minWidth: "6rem" }}
                        sortable
                      />
                      <Column
                        field="AssessmentPeriodStatus"
                        header="Status"
                        style={{ minWidth: "6rem" }}
                        sortable
                      />
                      <Column
                        field="EmployeeFullName"
                        body={nameBodyTemplate}
                        header="Score"
                        filter
                        filterField="fullName"
                        placeholder="Search by name"
                        style={{ minWidth: "12rem" }}
                        editor={(options) => RaiseByEditor(options)}
                        // sortable
                      />

                      <Column
                        field="RequestStatus"
                        header="Rating"
                        style={{ minWidth: "6rem" }}
                        editor={(options) => requestStatusEditor(options)}
                      />
                      <Column
                        header="Rating Scale"
                        field="CategoryName"
                        filterField="CategoryName"
                        style={{ minWidth: "6rem" }}
                        editor={(options) => categoryEditor(options)}
                        // sortable
                        filterPlaceholder="Search by category"
                      />
                      <Column
                        header="First Reviewer"
                        field="SubCategoryName"
                        filterField="SubCategoryName"
                        filterMenuStyle={{ width: "14rem" }}
                        style={{ minWidth: "10rem" }}
                        editor={(options) => subCategoryEditor(options)}
                        // sortable
                      />

                      <Column
                        field="FirstReviewerClosureDate"
                        header="First Review Date"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.FirstReviewerClosureDate).format(
                            "MMM DD YYYY"
                          )
                        }
                      />
                      <Column
                        field="CreatedDate"
                        header="Created Date"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.StartedOn).format("MMM DD YYYY")
                        }
                      />
                      <Column
                        field="StartedOn"
                        header="Started On"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.CreatedDate).format("MMM DD YYYY")
                        }
                      />
                      <Column
                        field="EndedOn"
                        header="Ended On"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.EndedOn).format("MMM DD YYYY")
                        }
                      />
                      <Column
                        field="From"
                        header="From"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.From).format("MMM DD YYYY")
                        }
                      />
                      <Column
                        field="To"
                        header="To"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) =>
                          moment(rowData.To).format("MMM DD YYYY")
                        }
                      />

                      <Column
                        field="AssignToName"
                        header="Second Reviewer"
                        body={assignBodyTemplate}
                        style={{ minWidth: "6rem" }}
                        editor={(options) => assignToEditor(options)}
                        filter
                      />

                      <Column
                        field="PriorityName"
                        header="HR"
                        filterMenuStyle={{ width: "6rem" }}
                        style={{ minWidth: "6rem" }}
                        editor={(options) => priorityEditor(options)}
                        filter
                        // sortable
                      />
                      <Column
                        field="SeverityName"
                        body={serverityContent}
                        header="Action"
                        filterMenuStyle={{ width: "6rem" }}
                        style={{ minWidth: "6rem" }}
                        editor={(options) => serverityEditor(options)}
                        filter
                        // sortable
                      />
                      {userUpdatePermission === true && (
                        <Column
                          header="Action"
                          rowEditor={true}
                          headerClassName="hide-filter-icon"
                        />
                      )}
                      {/* <Column
                        header=""
                        body={actionBodyTemplate}
                        headerClassName="hide-filter-icon"
                      /> */}
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="review-request"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Form Submitted Successfully. Now Sent the Review Request.
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Request to</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select
                    </option>
                    <option>Employee Review</option>
                    <option>Review</option>
                    <option>HR Review</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Add your Comment</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Sumbit
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default TeamAssessment;
